/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { MEDIA_SCREEN_BREAKPOINTS } from '@common/constants';
import { Heading } from '@components/common/primitives';
import { LogoContainer } from '@components/layouts/LogoContainer/LogoContainer';

export const CPPLikeContainer = styled.div`
  width: 20.875rem;
  min-height: 21.25rem;
  overflow: hidden;
`;

export const LogoutLogoContainer = styled(LogoContainer)`
  margin: 0;
  padding: 0.825rem 0;

  @media (max-width: ${MEDIA_SCREEN_BREAKPOINTS.s}) {
    background: none;
  }
`;

export const LogoutHeading = styled(Heading)`
  padding-top: 1.1rem;
  padding-bottom: 0.875rem;
  font-size: 1.5rem;
`;
